module.exports = __webpack_public_path__ + "static/media/investopedia.2164f4f2.png";